import React, { useReducer, useState } from "react";
import PropTypes from "prop-types";
import DeptTable from "../../elements/Tables/DeptTable/DeptTable";
import DeptCreationForm from "../../elements/Forms/DeptCreationForm/DeptCreationForm";

import { useFetch } from "../../../Utils/useFetch";

import {
  FETCH_ALL_DEPT_API,
} from "../../../Constants/Apis"
import { Button, Flex, Input, message, Modal } from "antd";
import { reducer } from "../../../Utils/CommonUtils";
import { deleteDept } from "../../../Services/DeptService";

const { Search } = Input;

const DeptPage = ({ history, userData }) => {
  const initialState = {
    searchKeyword: "",
    filteredInfo: {},
    sorter: {},
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deptId, setDeptId] = useState(null);

  const handleOpenModal = () => setIsModalVisible(true);
  const handleCloseModal = () => setIsModalVisible(false);

  const handleDelete = async (id) => {
    setDeptId(id);
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    try {
      await deleteDept(deptId);
      message.success("Dept deleted successfully");
      callReFetch();
    } catch (error) {
      message.error(
        error?.response?.data?.message ||
          "Something went wrong, failed to delete dept."
      );
    }
    setIsModalOpen(false);
  };

  const {
    fetchedData: { data },
    callReFetch,
    loading,
  } = useFetch(`${FETCH_ALL_DEPT_API}`, state);

  const handleSearch = (value) => {
    dispatch({ type: "searchKeyword", payload: value });
    callReFetch();
  };

  return (
    <div
      style={{
        width: "100vw",
        padding: "20px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          paddingBottom: "20px",
          display: "flex",
          justifyContent: "space-between",
          width: "50vw",
          maxWidth: "100vw",
        }}
      >
        <Button type="primary" onClick={handleOpenModal}>
          Create New Dept
        </Button>
        <Search
          placeholder="Search..."
          allowClear
          onSearch={handleSearch}
          style={{ width: "300px" }}
        />
      </div>

      <DeptTable
        history={history}
        loading={loading}
        data={data}
        callReFetch={callReFetch}
        dispatch={dispatch}
        userData={userData}
        handleDelete={handleDelete}
      />

      <Modal
        title="Create Dept"
        open={isModalVisible}
        footer={null}
        onCancel={handleCloseModal}
      >
        <DeptCreationForm
          history={history}
          userData={userData}
          callReFetch={callReFetch}
          onClose={handleCloseModal}
        />
      </Modal>

      <Modal
        title="Delete Dept"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={() => setIsModalOpen(false)}
      >
        <p>Are you sure you want to delete this dept?</p>
      </Modal>
    </div>
  );
};

DeptPage.propTypes = {};

export default DeptPage;
